import { render, staticRenderFns } from "./SpecifyExpiryDate.vue?vue&type=template&id=b4b828c2&scoped=true"
import script from "./SpecifyExpiryDate.vue?vue&type=script&lang=js"
export * from "./SpecifyExpiryDate.vue?vue&type=script&lang=js"
import style0 from "./SpecifyExpiryDate.vue?vue&type=style&index=0&id=b4b828c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b828c2",
  null
  
)

export default component.exports